import { render, staticRenderFns } from "./PackagingDetails.vue?vue&type=template&id=7030a919"
import script from "./PackagingDetails.vue?vue&type=script&lang=js"
export * from "./PackagingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports